module.exports = __webpack_public_path__ + "03_hige_white.7a7a14ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/03_hige_white.png
// module id = 4rPS
// module chunks = 0